export default __webpack_public_path__ + "static/media/practice-w-friends-icon.a4c69e80.svg";